export function renderSelectionMarks({
  svg,
  selectedEventIds,
  eventVisualsById,
}) {
  if (!svg) return
  let marksGroup = svg.select('#authoring-selection-marks')
  if (!marksGroup) {
    marksGroup = svg.group().attr({ id: 'authoring-selection-marks' })
  }
  while (marksGroup.node.firstChild) {
    marksGroup.node.removeChild(marksGroup.node.firstChild)
  }
  selectedEventIds.forEach(eventId => {
    const visuals = eventVisualsById.get(eventId) || []
    visuals.forEach(visual => {
      marksGroup.circle(visual.x, visual.y, visual.radius || 24).attr({
        fill: 'none',
        stroke: '#111827',
        'stroke-width': 5,
        'stroke-dasharray': '8,5',
        'pointer-events': 'none',
        opacity: 0.95,
      })
    })
  })
  svg.append(marksGroup)
}
